import { FunctionComponent, ReactElement, useState } from 'react';
import { InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import TextField, { TextFieldProps } from './TextField';

const PasswordField: FunctionComponent<TextFieldProps> = (props): ReactElement => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<TextField
			{...props}
			type={showPassword ? 'text' : 'password'}
			InputProps={{
				endAdornment: (
					<InputAdornment position="end">
						<IconButton
							aria-label={'Toggle password visibility'}
							onClick={() => setShowPassword(!showPassword)}
							onMouseDown={() => setShowPassword(!showPassword)}
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				),
			}}
		/>
	);
};

export default PasswordField;
